module.exports = __webpack_public_path__ + "img/close-icon.349dc812.svg";